/**
 * Правила нового пароля — спільні для всіх форм, де його задають: відновлення
 * (`AuthContainer`), картка співробітника й «Мій профіль» (`SPEC-005` ВП-3 (а),
 * D-28).
 *
 * Межа — копія беківської `UserEntity::PASSWORD_MIN_LENGTH`: фронт лише не
 * пускає запит, який однаково повернеться 422. Пару звіряє вартовий
 * «константи, скопійовані з беку» (`architectureGuard.test.ts`).
 */
export const MIN_PASSWORD_LENGTH = 8

export const PASSWORD_TEXTS = {
    mismatch: 'Паролі не збігаються.',
    tooShort: `Пароль має містити щонайменше ${MIN_PASSWORD_LENGTH} символів.`,
} as const

/**
 * Чому новий пароль не можна відправити, або `null`, якщо можна.
 *
 * Підтвердження до бека не доходить зовсім, тож розбіжність ловиться лише тут
 * (легасі її не перевіряло — D-28).
 */
export const newPasswordError = (password: string, confirmation: string): string | null => {
    if (password !== confirmation) return PASSWORD_TEXTS.mismatch
    if (password.length < MIN_PASSWORD_LENGTH) return PASSWORD_TEXTS.tooShort

    return null
}
